.color_option {
  padding: 0 9px;
  .color_img {
    max-width: 100%;
  }
  .title {
    font-family: var(--font-family, 'sofia-pro, sans-serif');
    font-size: 12px;
    font-weight: 700;
    line-height: 13.8px;
    text-align: center;
    color: #000;
    margin-top: 8px;
    min-height: 28px;
  }
  input {
    display: none;
  }
  label {
    cursor: pointer;
    position: relative;
    display: inline-block;
    width:100%;
    .color_img {
      display: block;
      outline: 3px solid transparent;
      border-radius: 8px;
      width: 100%;
      aspect-ratio: 1 / 1;
    }

  }
  &.checked label .color_img, label:has(input:checked) .color_img {
    outline: 3px solid #00B902;
  }
  &.checked label::before, label:has(input:checked)::before {
    content: url("data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%2211%22%20viewBox%3D%220%200%2012%2011%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M5.63828%2010.3054L0.910156%206.62443L2.25453%204.90025L5.15797%207.16064L9.94984%200.250488L11.748%201.4953L5.63828%2010.3054Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E");
    position: absolute;
    top:-10px;
    right:-10px;
    background-color: #00B902;
    border-radius: 50%;
    color:#fff;
    width: 20px;
    height: 20px;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
  }


}
